var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "shortcutComponent",
    {
      ref: "shortCutComponent",
      attrs: { showBtnOk: false, modalClass: "lm-modal" },
    },
    [
      _vm.textoCriterios && _vm.textoCriterios.length > 0
        ? _c(
            "div",
            { attrs: { slot: "component" }, slot: "component" },
            [_c("vue-markdown-it", { attrs: { source: _vm.textoCriterios } })],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }